// extracted by mini-css-extract-plugin
export default {"app":"SettingProfile_app__Im5k9","headerBar":"SettingProfile_headerBar__alArv","view":"SettingProfile_view__-0pa5"};